import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, EMPTY, map, Observable, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { UserProfile } from '../models/user-profile.model';
import { ToasterService } from '../services/toaster.service';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { NavigationService } from '../services/navigation.service';

export const userDetailsResolver: ResolveFn<Observable<UserProfile>> = (
  route: ActivatedRouteSnapshot,
) => {
  const userId: string = route.params['userId'].split('.html')[0];
  const apiService = inject(ApiService);
  const toasterService = inject(ToasterService);
  const utilityService = inject(UtilityService);
  const navigationService = inject(NavigationService)

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.publicProfile}${userId}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.getUserOpenProfileDetail(userId).pipe(
      tap(() => {
        apiService.setProfileVisitCount(userId).subscribe();
      }),
      map((resp) => {
        return resp;
      }),
      catchError((error) => {
        toasterService.error('User details not found');
        navigationService.handleResolverError(error);
        return EMPTY;
      }),
    );
  }
};
